var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWidgetmenuUploads(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33334 23.9999C7.6697 23.9999 6.07421 23.3677 4.89785 22.2425C3.72148 21.1173 3.06061 19.5912 3.06061 17.9999C3.06061 16.4086 3.72148 14.8824 4.89785 13.7572C6.07421 12.632 7.6697 11.9999 9.33334 11.9999C9.72625 10.2494 10.8757 8.71117 12.5288 7.72347C13.3473 7.23442 14.2649 6.89525 15.229 6.72534C16.1932 6.55542 17.1851 6.55809 18.1482 6.73319C19.1112 6.90828 20.0265 7.25238 20.8417 7.74583C21.657 8.23928 22.3563 8.87241 22.8997 9.60909C23.4431 10.3458 23.8199 11.1716 24.0087 12.0393C24.1975 12.9071 24.1946 13.7998 24 14.6665H25.3333C26.571 14.6665 27.758 15.1582 28.6332 16.0334C29.5083 16.9085 30 18.0955 30 19.3332C30 20.5709 29.5083 21.7579 28.6332 22.633C27.758 23.5082 26.571 23.9999 25.3333 23.9999H24",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20L16 16L20 20",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16V28",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetmenuUploads);
export default __webpack_public_path__ + "static/media/widgetmenu_uploads.677b0d616b4816abc0f9041a1d4d2e8f.svg";
export { ForwardRef as ReactComponent };